<script>
import cloneDeep from 'lodash/cloneDeep'
import { messageStore, messageDelete } from '@utils/message'
import { getSavedState } from '@utils/browser-help'
const initData = () => {
  return {
    level: 0,
    state: 1,
    title: '',
  }
}

export default {
  data() {
    return {
      submitData: {},
      eachItem: {
        parentTitle: '保養',
        content: [{ childTitle: '卸妝' }, { childTitle: '洗顏' }],
      },
      editTitle: '', // 商品分類修改視窗，要顯示的字
      editItem: {}, // 要修改的資料
      editVisibleDialog: false,
      categoryList: [], // 所有分類列表
      dialogCategoryList: [], // 彈窗的分類列表
      maintainOpenArr: [],
      addCommidityCategory: false, // 新增商品分類 跳窗
      submitDataCreate: Object.assign(initData()),
      isDeleteMode: false,
      allChildrenList: [], // 所有子分類
    }
  },
  computed: {
    formRules() {
      return {
        title: [
          {
            required: true,
            message: '請輸入 名稱',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  async created() {},
  async mounted() {
    this.isDeleteMode = await getSavedState('isDeleteMode')
    await this.tryToFetchList()
  },
  methods: {
    /**
     * @description 搜尋服務列表
     */
    async tryToFetchList() {
      this.categoryList = await this.$store.dispatch('product/fetchServiceCategory', {
        onlyLeaf: 0,
        type: 'goods',
      })
      this.dialogCategoryList = await this.$store.dispatch('product/fetchServiceCategory', {
        onlyLeaf: 1,
        type: 'goods',
      })
      this.allChildrenList = []
      this.categoryList.forEach((item) => {
        if (item.children && item.children.length === 0) {
          this.$set(item, 'expendChildren', [])
          this.allChildrenList.push(item)
        }
        if (item.children && item.children.length > 0) {
          let result = this.flattenChildren(item)
          this.$set(item, 'expendChildren', result.reverse().slice(1))
          this.allChildrenList.push(...result)
        }
      })
      console.log('this.allChildrenList', this.allChildrenList)
    },
    /**
     * @description 攤平children
     */
    flattenChildren(obj) {
      const flattenedChildren = []
      if (obj.children) {
        for (const child of obj.children) {
          flattenedChildren.push(...this.flattenChildren(child))
        }
      }
      flattenedChildren.push(obj)
      return flattenedChildren
    },
    /**
     * @description 驗證資料
     */
    validateSubmitDataCreate(submitData) {
      return new Promise((resolve, reject) => {
        if (submitData.title.length === 0) {
          reject(new Error('請輸入名稱'))
        }
        resolve()
      })
    },
    /**
     * @description 新增商品分類視窗（關掉）
     */
    async tryToSaveAndCloseAddCategory() {
      try {
        await this.validateSubmitDataCreate(this.submitDataCreate)
        const item = this.allChildrenList.find((item) => {
          return item.id === this.submitDataCreate.id
        })
        console.log('🚀 ~ file: TabCategories.vue:107 ~ tryToSaveAndCloseAddCategory ~ item:', item)
        let storeId = null
        if (this.submitDataCreate.id) {
          storeId = item.parentId ? item.id : item.id
        }
        await this.$store.dispatch('product/storeServiceCategory', {
          title: this.submitDataCreate.title,
          id: null,
          state: 1,
          introtext: '',
          description: '',
          type: 'goods',
          parentId: storeId,
        })
        await this.tryToFetchList()
        this.addCommidityCategory = false
        this.resetSubmitDataCreate()
      } catch (error) {
        console.error(error.message)
        this.$message.error(error.message)
      }
    },
    /**
     * @description 重新設定要創建的資料
     */
    resetSubmitDataCreate() {
      this.submitDataCreate = Object.assign(initData())
      this.$set(this.submitData, 'title', '')
      this.$set(this.submitData, 'id', null)
    },
    /**
     * @description 新增商品分類
     */
    addToMainTainArr() {
      this.addCommidityCategory = true
    },
    /**
     * @description 打開編輯商品分類的視窗
     */
    tryToEdit(item, index, mode) {
      try {
        this.decideEditTitle(item, index, mode)
        this.editItem = item
        this.editVisibleDialog = true
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 決定v-model要顯示哪個title
     */
    decideEditTitle(item, index, mode) {
      try {
        if (mode === 'parent') {
          this.editTitle = item['title']
        }
        if (mode === 'child') {
          this.editTitle = item['title']
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 開啟 or 關閉 單行
     */
    openCloseDrawer(index) {
      this.$set(this.maintainOpenArr, index, !this.maintainOpenArr[index])
    },
    /**
     * @description 編輯商品分類 儲存
     */
    async tryToSave() {
      try {
        await this.validateSubmitDataCreate(this.editItem)
        this.$set(this.editItem, 'params', '')
        this.$set(this.editItem, 'state', 1)
        // this.$set(this.editItem, 'title', this.editTitle)
        const { code } = await this.$store.dispatch('product/storeServiceCategory', this.editItem)
        if (code === 200) {
          messageStore('edit')
          await this.tryToFetchList()
          this.editVisibleDialog = false
        }
      } catch (error) {
        console.error(error.message)
        this.$message.error(error.message)
      }
    },
    /**
     * @description 新增商品分類
     */
    addCommodityCategory() {},
    /**
     * @description 指派上層分類
     */
    changeParentCreate() {},
    async tryToRemove(id) {
      await this.$store.dispatch('product/removeServiceCategory', { ids: [id] })
      this.$message({
        message: '刪除成功',
        type: 'success',
      })
      await this.tryToFetchList()
    },
  },
}
</script>
<template>
  <div :class="$style.basicSetForm">
    <h4 data-tour-text="" class="form-block-title justify-content-start fs-lg">
      <span class="isStyleRequired">分類設定</span>
      <span class="ml-3 text-danger text-secondary fs-sm">因商品分類刪除會造成系統錯誤，若需刪除分類請聯絡負責業務</span>
    </h4>
    <div :class="$style.mainBlock">
      <div :class="$style.mainBlock__innerMain">
        <div class="accrodion">
          <div v-for="(item, index) in categoryList" :key="index">
            <div class="accrodion-item">
              <div class="accrodion-header">
                <div class="accrodion-title" @click="openCloseDrawer(index)">
                  <BaseIcon name="angle-right" :class="{ [$style.angleRotate]: maintainOpenArr[index] }" style="font-size: 20px" />
                  <span style="margin-left: 14px">{{ item.categoryTitle }}</span>
                </div>
                <div class="accrodion-tooltip">
                  <span v-if="'expendChildren' in item" style="margin-right: 14px">{{ item.expendChildren.length + 1 }}</span>
                  <el-tooltip content="編輯" placement="top">
                    <el-button class="is-no-style" @click="tryToEdit(item, index, 'parent')">
                      <BaseIcon name="edit" style="font-size: 20px; padding: 0 14px" class="text-primary" />
                    </el-button>
                  </el-tooltip>
                  <el-tooltip v-if="isDeleteMode" content="刪除" placement="top">
                    <el-button class="is-no-style" type="danger" plain size="mini" @click.stop="tryToRemove(item.id)">
                      <BaseIcon name="trash-alt" style="font-size: 20px" />
                    </el-button>
                  </el-tooltip>
                </div>
              </div>
              <div v-for="(contentItem, contentIndex) in item.expendChildren" :key="`content${contentIndex}`">
                <div class="accordion-collapse collapse" :class="{ show: maintainOpenArr[index] }">
                  <div class="accordion-body">
                    <ul class="list">
                      <li class="list-item">
                        <div class="list-item-title">{{ contentItem.categoryTitle }}</div>
                        <div class="list-item-tooltip">
                          <el-tooltip content="編輯" placement="top">
                            <el-button class="is-no-style" @click="tryToEdit(contentItem, contentIndex, 'child')">
                              <BaseIcon name="edit" style="font-size: 20px; padding: 0 14px" class="text-primary" />
                            </el-button>
                          </el-tooltip>
                          <el-tooltip v-if="isDeleteMode" content="刪除" placement="top">
                            <el-button class="is-no-style" type="danger" plain size="mini" @click.stop="tryToRemove(contentItem.id)">
                              <BaseIcon name="trash-alt" style="font-size: 20px" />
                            </el-button>
                          </el-tooltip>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.mainBlock__footer">
      <el-button class="btn-block is-round" @click="addToMainTainArr"> <BaseIcon name="plus" style="font-size: 14px; padding: 0 14px" />新增商品分類 </el-button>
    </div>
    <el-dialog :title="'編輯商品分類'" :destroy-on-close="true" :visible.sync="editVisibleDialog" top="0" width="550px" append-to-body>
      <el-form ref="editForm" :model="editItem" label-position="top" class="el-form--floating">
        <el-form-item label="名稱" required>
          <el-input v-model="editItem.title" placeholder="請輸入分類名稱"></el-input>
        </el-form-item>
        <el-form-item label="是否啟用" required>
          <el-switch v-model="editItem.state" active-text="啟用" inactive-text="禁用" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div :class="$style.bottomBtn">
        <el-button class="is-round" style="width: 50%" @click="editVisibleDialog = false">取消</el-button>
        <el-button class="is-round" style="width: 50%" type="primary" @click="tryToSave">儲存變更</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="'新增商品分類'" :destroy-on-close="true" :visible.sync="addCommidityCategory" top="0" width="550px" append-to-body>
      <el-form ref="newForm" :rules="formRules" :model="submitDataCreate" label-position="top" class="el-form--floating mb-5 mb-md-0">
        <el-form-item label="名稱" prop="title" required>
          <el-input v-model="submitDataCreate.title" placeholder="請輸入分類名稱"></el-input>
        </el-form-item>
        <el-form-item label="指派上層分類" prop="parentId">
          <el-select v-model="submitDataCreate.id" placeholder="指派上層分類" @change="changeParentCreate">
            <el-option value label="無上層分類"></el-option>
            <el-option v-for="(item, index) in allChildrenList" :key="index" :label="item.categoryTitle" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div :class="$style.bottomBtn">
        <el-button class="is-round" style="width: 50%" @click="addCommidityCategory = false">取消</el-button>
        <el-button class="is-round" style="width: 50%" type="primary" @click="tryToSaveAndCloseAddCategory">儲存變更</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.basicSetForm {
  :global {
    overflow: scroll;
    width: 100%;
    background-color: white;
    padding: 18px 20px 100px;

    .btn-block {
      display: block;
      width: 100%;
    }

    .accrodion {
      .show {
        display: block !important;
      }

      .collapse {
        display: none;
      }

      &-collapse {
        transition: 0.5s;
      }

      &-header {
        border: 1px solid #f4f4f4;
        border-radius: 8px;
        height: 50px;
        width: 100%;
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 10px 0;
        padding: 0 18px;

        &:hover {
          cursor: pointer;
        }
      }

      &-title {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
      }

      &-tooltip {
        display: flex;
        align-items: center;
      }

      .list {
        padding-left: 22px;

        &-item {
          border: 1px solid #f4f4f4;
          border-radius: 8px;
          height: 50px;
          width: 100%;
          background-color: white;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 2px 0;
          padding: 0 18px;
        }
      }
    }
  }
}

.angleRotate {
  transform: rotate(90deg);
}

.mainBlock {
  background-color: $color-line;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  height: 500px;
  overflow-y: auto;
  border-radius: $border-radius;

  &__innerMain {
    padding: 20px;
  }

  &__innerMainParent {
    height: 50px;
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__footer {
    background-color: $color-line;
    padding: 20px;
  }
}

.bottomBtn {
  display: flex;
}
</style>
